export const REQUEST_ORGS = 'REQUEST_ORGS';
export const RECEIVE_ORGS = 'RECEIVE_ORGS';
export const ORGS_REQUEST_FAILED = 'ORGS_REQUEST_FAILED';

export const DELETE_ORG_REQUESTED = 'DELETE_ORG_REQUESTED';
export const DELETE_ORG_REQUEST_COMPLETED = 'DELETE_ORG_REQUEST_COMPLETED';
export const DELETE_ORG_REQUEST_FAILED = 'DELETE_ORG_REQUEST_FAILED';

export const RESET_ORGS_VIEW_STATE = 'RESET_ORGS_VIEW_STATE';
